module.exports = __webpack_public_path__ + "img/vonestis_spa_04.91897bff.jpg";